import { Scene, GameObjects } from "phaser";
import { getResolution } from "../lib/config";

export class MainMenu extends Scene {
  background: GameObjects.Image;
  seagull: GameObjects.Image;
  logoExplora: GameObjects.Image;
  logoVDB: GameObjects.Image;
  startBtn: GameObjects.Image;
  title: GameObjects.Text;

  constructor() {
    super("MainMenu");
  }

  create() {
    const resolution: any = getResolution();

    // Next Scene
    this.background = this.add.image(
      resolution.width / 2,
      resolution.height / 2,
      "bginit"
    );

    this.seagull = this.add.image(290, 300, "seagull");
    this.logoExplora = this.add.image(
      250,
      resolution.height * 0.9,
      "logoexplora"
    );
    this.logoVDB = this.add.image(
      resolution.width * 0.78,
      resolution.height * 0.25,
      "logovdb"
    );
    // Button
    let textureBtn = "startBtnOff";
    this.startBtn = this.add
      .image(resolution.width * 0.83, resolution.height * 0.75, textureBtn)
      .setInteractive();
    // Button Actions
    this.startBtn.on("pointerover", () =>
      this.startBtn.setTexture("startBtnOn")
    );
    this.startBtn.on("pointerout", () =>
      this.startBtn.setTexture("startBtnOff")
    );
    this.startBtn.on("pointerdown", () => this.changeScene());
    /* this.input.once("pointerdown", () => {
      this.scene.start("Game");
    }); */
  }

  changeScene() {
    this.scene.start("Game").start("HUD").remove();
  }
}
